@use "~theme/breakpoints";

.container {
  display: flex;
  flex-direction: column;
}

.description {
  margin: 24px 16px 12px;

  @include breakpoints.desktop {
    min-height: 88px; // Ensure space for 4-line addresses
  }
}

.rule {
  border: {
    top: 1px solid var(--blue-01-at-30);
    bottom: none;
    left: none;
    right: none;
  }
  margin: 0;
  width: 100%;
}

.doctors {
  margin: 16px 24px 8px;

  > * {
    margin-bottom: 12px;
  }
}

.button {
  flex-grow: 0;
  margin: auto 24px 24px;
}
